@if (systemsPercentages.length) {
  <patron-card
    header="Porcentagem do apontamento por sistema"
    [contentTemplate]="systemsPercentagesContent">
    <ng-template #systemsPercentagesContent>
      @for (sp of systemsPercentages; track sp; let i = $index) {
        <div
          pDroppable
          (onDrop)="
            onDrop({
              event: $event,
              sp: sp,
              targetIndex: i,
            })
          ">
          <div
            class="row align-items-center"
            pDraggable
            (onDragStart)="
              onDragStart({
                event: $event,
                sp: sp,
                sourceIndex: i,
              })
            ">
            <div class="col-auto py-0">
              <patron-icon class="me-2 cursor-pointer" name="bi-grip-horizontal"></patron-icon>
            </div>
            <div class="col py-0">
              <patron-slider
                [label]="sp.system?.description"
                [value]="sp.percentageRange"
                [range]="true"
                [rightText]="sp.timeLabel + ' (' + sp.percentage + '%)'"
                (onSlideEnd)="systemPercentageChanged(i, sp, $event)"></patron-slider>
            </div>
            <div class="col-auto py-0">
              <patron-button
                type="button"
                [loading]="loading"
                size=""
                color="danger"
                iconName="pi-trash"
                variant="ghost"
                [disabled]="systemsPercentages.length === 1"
                (click)="deleteSystemPercentage(sp, i)">
                @if (sp.confirmDelete) {
                  <span>Confirmar</span>
                }
              </patron-button>
            </div>
          </div>
        </div>
      }
    </ng-template>
  </patron-card>
}
